import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '自述文件' },
            children: [
                {   // 废弃
                    path: '/class_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/sys_settings/class_manage.vue'),
                    meta: { title: '部门管理' }
                },
                {
                    path: '/role_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/sys_settings/role_manage.vue'),
                    meta: { title: '角色管理' }
                },
                {
                    path: '/account_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/sys_settings/account_manage.vue'),
                    meta: { title: '账号管理' }
                },
                {
                    path: '/store_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/sys_settings/store_manage.vue'),
                    meta: { title: '门店管理' }
                },
                {
                    path: '/storeEquipment_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/equipmentManagement'),
                    meta: { title: '设备列表' }
                },
                {   // 废弃
                    path: '/offline_staff',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/sys_settings/offline_staff.vue'),
                    meta: { title: '岗下员工' }
                },
                {
                    path: '/wx_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/sys_settings/wx_manage.vue'),
                    meta: { title: '小程序配置' }
                },
                {
                    path: '/indent_order',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/order_manage/indent_order.vue'),
                    meta: { title: '代购订单' }
                },
                {
                    path: '/device_order',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/order_manage/device_order.vue'),
                    meta: { title: '设备订单' }
                },
                {
                    path: '/active_order',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/order_manage/active_order.vue'),
                    meta: { title: '活动订单' }
                },
                {
                    path: '/vip_order',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/order_manage/vip_order.vue'),
                    meta: { title: '活动订单' }
                },
                {
                    path: '/consultation_order',
                    name: 'consultation_order',
                    component: () => import('@/components/page/consultation/perscription/list.vue'),
                    meta: { title: '问诊订单', pageMode: 'order' }
                },
                {
                    path: '/member_list',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/member_center/member_list.vue'),
                    meta: { title: '会员列表' }
                },
                {
                    path: '/menber_base_info',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/member_center/menber_base_info.vue'),
                    meta: { title: '基础信息' }
                },
                {
                    path: '/ndc_patient_list',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/member_center/ndc_patient_list.vue'),
                    meta: { title: '慢病会员' }
                },
                {
                    path: '/user_info_manage',
                    name: 'user_info_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/common/user/user_info_manage.vue'),
                    // component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/member_detail/index.vue'),
                    meta: { title: '会员基础信息' }
                },
                {
                    path: '/verification_manage',
                    name: 'verification_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/cancelAfterVerification'),
                    meta: { title: '卡券核销记录' }
                },
                {
                    path: '/payMenber',
                    name: 'payMenber',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/payMenber'),
                    meta: { title: '卡券核销' }
                },

                {
                    path: '/record',
                    name: 'record',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/record'),
                    meta: { title: '实体卡核销' }
                },
                {
                    path: '/banner_manage',
                    name: 'banner_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/oper_center/banner_manage.vue'),
                    meta: { title: 'banner管理' }
                },
                {
                    path: '/healthManage',
                    component: () => import('../components/page/medicalTeamManage/healthManage/index'),
                    name: 'health_manage',
                    meta: { title: '健康管理师管理' },
                    hidden: true
                },
                {
                    path: '/healthManage_detail',
                    component: () => import('../components/page/medicalTeamManage/healthManage/doctorDetail'),
                    name: 'healthManage_detail',
                    meta: { title: '健康管理师管理详情' },
                    hidden: true
                },
                {
                    path: '/storeManage',
                    component: () => import('../components/page/medicalTeamManage/storeManage'),
                    name: 'storeManage',
                    meta: { title: '门店管理' },
                    hidden: true
                },

                {
                    path: '/404',
                    component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
                    meta: { title: '403' }
                },
                {
                    path: '/my_home',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/my_home.vue'),
                    meta: { title: '首页' }
                },
                {
                    path: '/user_profile',
                    name: 'user_profile',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/user/profile.vue'),
                    meta: { title: '个人中心' }
                },
                {
                    path: '/qrcode',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/qrcode.vue'),
                    meta: { title: '专属二维码' }
                },
                {
                    path: '/cushion_index',
                    component: () => import('../components/page/cushion/index.vue'),
                    meta: { title: '坐垫设备' }
                },
                {
                    path: '/report_index',
                    component: () => import('../components/page/cushion/report_index.vue'),
                    meta: { title: '报告设备' }
                },
                {
                    path: '/issuance_record',
                    component: () => import('../components/page/cushion/issuanceRecord.vue'),
                    meta: { title: '下发记录' }
                },
                {
                    path: '/cushion_drug',
                    component: () => import('../components/page/cushion/drug.vue'),
                    meta: { title: '药品设置' }
                },
                {
                    path: '/prescript_record',
                    component: () => import('../components/page/prescriptionRecord/PrescriptRecord.vue'),
                    meta: { title: '处方记录' }
                },
                {
                    path: '/hardware_list',
                    component: () => import('../components/page/hardwareEquipment/index.vue'),
                    meta: { title: '硬件设备' }
                },
                {
                    path: '/hardware_chronic',
                    name: 'hardware_chronic',
                    component: () => import('../components/page/hardwareEquipment/chronic_device.vue'),
                    meta: { title: '慢病设备' }
                },
                {
                    path: '/hardware_chronic_purchase',
                    name: 'hardware_chronic_purchase',
                    component: () => import('../components/page/hardwareEquipment/chronic_device_purchase.vue'),
                    meta: { title: '设备采购' }
                },
                {
                    path: '/hardware_chronic_purchase_success',
                    name: 'hardware_chronic_purchase_success',
                    component: () => import('../components/page/hardwareEquipment/chronic_device_purchase_success.vue'),
                    meta: { title: '下单成功' }
                },
                {
                    path: '/hardware_issue_list',
                    component: () => import('../components/page/hardwareEquipment/index_issue_list.vue'),
                    meta: { title: '设备下发记录' }
                },
                {
                    path: '/health_workbench',
                    name: 'health_workbench',
                    component: () => import('@/components/page/healthManage/index.vue'),
                    meta: { title: '一体化健康管理' }
                },
                {
                    path: '/health_report',
                    name: 'health_report',
                    component: () => import('@/components/page/healthReport/index.vue'),
                    meta: { title: '健康报告' }
                },
                {
                    path: '/health_tag',
                    name: 'health_tag',
                    component: () => import('@/components/page/healthTag/index.vue'),
                    meta: { title: '健康标签' }
                },
                {
                    path: '/health_plan',
                    name: 'health_plan',
                    component: () => import('@/components/page/healthPlan/index.vue'),
                    meta: { title: '健康方案' }
                },
                {
                    path: '/purchase_detect',
                    name: 'purchase_detect',
                    component: () => import('@/components/page/purchaseDetect/index.vue'),
                    meta: { title: '购药检测' }
                },
                {
                    path: '/consultation_medicine',
                    name: 'consultation_medicine',
                    component: () => import('@/components/page/consultation/medicine/medicineManagement.vue'),
                    meta: { title: '药品管理' }
                },
                {
                    path: '/consultation_diagnosis',
                    name: 'consultation_diagnosis',
                    component: () => import('@/components/page/consultation/perscription/list.vue'),
                    meta: { title: '诊断记录' }
                },
                {
                    path: '/consultation_dispense',
                    name: 'consultation_dispense',
                    component: () => import('@/components/page/consultation/perscription/dispenseList.vue'),
                    meta: { title: '煎配中心' }
                },
                {
                    path: '/device_data',
                    name: 'device_data',
                    component: () => import('../components/page/deviceData/index.vue'),
                    meta: { title: '设备数据' }
                },
                {
                    path: '/device_data_detail',
                    name: 'device_data_detail',
                    component: () => import('../components/page/deviceData/detail.vue'),
                    meta: { title: '设备数据详情' }
                },
                {
                    path: '/activity_write_off',
                    name: 'activity_write_off',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/activity/activity_write_off.vue'),
                    meta: { title: '活动核销' }
                },
                {
                    path: '/activity_verify_list',
                    name: 'activity_verify_list',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/activity/activity_verify_list.vue'),
                    meta: { title: '活动核销记录' }
                },
                {
                    path: '/card_member_verify',
                    name: 'card_member_verify',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/activity/card_member_verify.vue'),
                    meta: { title: '卡券核销' }
                },
                {
                    path: '/unified_scan_verify',
                    name: 'unified_scan_verify',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/activity/unified_scan_verify.vue'),
                    meta: { title: '扫码核销' }
                },
            ]
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/login.vue'),
            meta: { title: '登录' }
        },
        {
            path: '/route-login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/routeLogin.vue'),
            meta: { title: '登录' }
        },
        {
            path: '*',
            redirect: '/404'
        }, 
        {
            path: '/getPreAuthorizationPage',
            component: () => import(/* webpackChunkName: "login" */ '../components/common/getPreAuthorizationPage.vue'),
            meta: { title: '授权' }
        },
        {
            path: '/AuthorizationRedirectUri',
            component: () => import(/* webpackChunkName: "login" */ '../components/common/AuthorizationRedirectUri.vue'),
            meta: { title: '回调' }
        }
    ]
});
